module.exports = __webpack_public_path__ + "static/media/RSmartPlus+E.b929b793.jpg";